<div class="wizard-close-box">
  <div class="wizard-close-box-img">
    <img src="assets/img/doctor.svg" />
  </div>
  <div class="wizard-close-box-text">
    <p>{{'wizard.close-dialog.content'|translate}}</p>
    <div class="btn-list">
      <button class="primary-btn" (click)="ref.close(false)">{{'wizard.close-dialog.btn-close.no' | translate}}</button>
      <button class="link-btn" (click)="ref.close(true)">{{'wizard.close-dialog.btn-close.ok' | translate}}</button>
    </div>
  </div>
</div>